import script from "./detailBatch.vue?vue&type=script&setup=true&lang=js"
export * from "./detailBatch.vue?vue&type=script&setup=true&lang=js"

import "./detailBatch.vue?vue&type=style&index=0&id=287c493a&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287c493a"]])

export default __exports__